function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 2571;


//////////////////
// WEBPACK FOOTER
// ./src/contracts \.\/.+\.json$
// module id = 2571
// module chunks = 1